<template>
  <v-select 
    label="name" 
    :placeholder="$t('vendor')" 
    :filterable="false" 
    :options="vendors" 
    @search="onSearchVendors"
    :loading="vendorSelect.loading" 
    v-model="internalValue" 
    class="w-full",
    :disabled="disabled"
  />
</template>

<script setup>
import vSelect from 'vue-select';
import debounce from 'lodash/debounce';
import request from '../../../services/bankAccountsService';
import { ref, watch } from 'vue';

const props = defineProps({
  value: { type: Object, default: null },
  disabled:{ type:Boolean, default:false }
});

const emit = defineEmits(['input']);

const vendors = ref([]);
const vendorSelect = ref({ loading: false, disabled: true });


const internalValue = ref(props.value);

watch(internalValue, (val) => {
  emit('input', val);
})


watch(() => props.value, (val) => {
  internalValue.value = val;
})

const onSearchVendors = debounce(async (search) => {
  try {
    if (search.length > 2) {
      vendorSelect.value.loading = true;
      const res = await request.getVendors({ search });
      vendorSelect.value.loading = false;
      vendors.value = res.vendors;
    }
  } catch (err) {
    vendorSelect.value.loading = false;
    vendors.value = [];
  }
}, 300)
</script>